import { SectionHeading } from './SectionHeading'

const works = [
  {
    title: 'AI・業務システムの開発',
    label: 'AI / DX / システム開発',
    role: 'CTO',
    body: '業務効率化のためのAIシステムや各種Webシステムで、要件定義から設計・実装、インフラ構築、運用までを担当'
  },
  {
    title: 'お絵描きばりぐっどくん',
    label: '生成AI / LINE Bot',
    role: '個人開発',
    body: 'Stable DiffusionをLINEで使えるチャットUIとして提供し、友達登録240万人超の規模まで運用しながら、翻訳キャッシュなどで運用コストを約10分の1に削減'
  },
  {
    title: 'MAPCHAIN',
    label: '防災 / LINE × ブロックチェーン',
    role: 'ハッカソン開発',
    body: 'LINEからの災害報告をリアルタイムに反映するデジタルハザードマップを開発し、Yahoo! JAPAN主催「Digital Hack Day 2021」で特別賞を受賞'
  }
]

export const SelectedWork = () => {
  return (
    <section id="works" className="py-12 border-t border-ink-100">
      <SectionHeading number="02" title="つくってきたもの" />
      <div className="space-y-6">
        {works.map(({ title, label, role, body }) => (
          <article key={title} className="border-l border-ink-200 pl-5">
            <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
              <span className="font-mono text-xs tracking-wider text-ink-600">
                {label}
              </span>
              <span className="font-mono text-xs tracking-wider text-ink-600">
                {role}
              </span>
            </div>
            <h3 className="mt-2 text-lg font-semibold leading-relaxed text-ink-800">
              {title}
            </h3>
            <p className="mt-2 text-base leading-[1.9] text-ink-700">{body}</p>
          </article>
        ))}
      </div>
    </section>
  )
}
